<p-dialog [visible]="display" [style]="{width: '30vw'}" [closeOnEscape]="false" [closable]="false" [modal]="true">
  <div class="grid align-itens-center" *ngIf="data">
    <div class="col-12 text-center"> <i class="pi {{data.iconStatus}}" style="font-size: 2rem"></i></div>
    <div class="col-12 text-center"> <span [innerHtml]="data.statusMessage"></span></div>
  </div>
  <ng-template pTemplate="footer">
    <button type="button" pButton class="p-button-success" label="Fechar" (click)="close()"></button>
  </ng-template>
</p-dialog>
